'use strict';

bbw.service.SmileySvc = Class({

    _regexps: undefined,
    _markerRegexp: undefined,
    _collection: undefined,

    $sce: null,

    $inject: ['$sce'],

    construct: function($sce) {
        this.$sce = $sce;
    },

    getSmileysCollection: function() {
        if (!this._collection) {
            this._collection = [];
            Object.keys(bbw.service.SmileySvc.registry).forEach(function(name) {
                this._collection.push({
                    name: name,
                    url: this.$sce.trustAsResourceUrl(
                        this.getUrl(name)
                    )
                });
            }.bind(this));
        }
        return this._collection;
    },

    replaceImagesToTextMarkersInNode: function(node) {
        var images = node.querySelectorAll('img');
        if (images.length) {
            Array.prototype.forEach.call(images, function(img) {
                var match = bbw.configuration.smiley.isSmileyUri(new Uri(img.src).path());
                if (match) {
                    var name = match[1];
                    if (name) {
                        var markedText = this.getMarkedText(name);
                        if (markedText) {
                            var textNode = document.createTextNode(markedText);
                            try {
                                node.replaceChild(textNode, img);
                            } catch (e) {
                                // pass
                            }
                        }
                    }
                }
            }.bind(this));
        }
    },

    replaceCodesToMarkers: function(s) {
        return this._getRegexps().reduce(function(carry, replacement) {
            return carry.replace(replacement.re, replacement.marker);
        }, s);
    },

    textWithMarkersToHtml: function(text) {
        return text.replace(this._getMarkerRegexp(), function(_, name) {
            return this.getNodeHtml(name);
        }.bind(this));
    },

    getNodeHtml: function(name) {
        if (!this._isKnownName(name)) {
            return undefined;
        }
        //noinspection HtmlUnknownTarget
        return ngtk.tools.string.format(
            '<img src="{0}" alt="{1}" class="{2}">',
            this.getUrl(name),
            this._getFirstCode(name),
            bbw.service.SmileySvc.imgClass
        );
    },

    getNode: function(name) {
        if (!this._isKnownName(name)) {
            return undefined;
        }
        var img = document.createElement('img');
        img.src = this.getUrl(name);
        img.alt = name;
        img.setAttribute('class', bbw.service.SmileySvc.imgClass);
        return img;
    },

    getMarkedText: function(name) {
        return this._isKnownName(name)
            ? bbw.configuration.smiley.marker_start + name + bbw.configuration.smiley.marker_end
            : undefined;
    },

    _getMarkerRegexp: function() {
        if (!this._markerRegexp) {
            this._markerRegexp = new RegExp(bbw.configuration.smiley.marker_start + '([a-z]+)' + bbw.configuration.smiley.marker_end, 'g');
        }

        return this._markerRegexp;
    },

    _getFirstCode: function(name) {
        return this._isKnownName(name) ? bbw.service.SmileySvc.registry[name][0] : ''
    },

    _isKnownName: function(name) {
        return angular.isDefined(bbw.service.SmileySvc.registry[name]);
    },

    getUrl: function(name) {
        return ngtk.tools.string.format(bbw.configuration.smiley.url, name);
    },

    _getRegexps: function() {
        if (!this._regexps) {
            this._regexps = [];
            angular.forEach(bbw.service.SmileySvc.registry, function(codes, name) {
                codes.forEach(function(code) {
                    var re = new RegExp(ngtk.tools.string.escapeRegexp(code) + '(\\b|\\B|$)', 'gi');
                    this._regexps.push({
                        re: re,
                        marker: this.getMarkedText(name)
                    });
                }.bind(this));
            }.bind(this));
        }
        return this._regexps;
    },

    statics: {
        imgClass: 'bbw-sm',
        registry: {
            "aa": [
                ":-)",
                ":)",
                "=)",
                "+)"
            ],
            "ab": [
                ";-)",
                ";)",
                "^_~"
            ],
            "ac": [
                ":-(",
                ":(",
                "+(",
                "=("
            ],
            "ad": [
                "O:-)",
                "O:)",
                "O+)",
                "O=)",
                "0:-)",
                "0:)",
                "0+)",
                "0=)"
            ],
            "ae": [
                ":-P",
                ":P",
                ":-p",
                ":p",
                "+P",
                "=P",
                "+p",
                "=p",
                ":-b",
                ":b",
                "+b",
                "=b"
            ],
            "af": [
                "8-)",
                "8)",
                "B)"
            ],
            "ag": [
                ":-D",
                ":D",
                "+D",
                "=D"
            ],
            "ah": [
                ":-[",
                ":[",
                ";'>",
                ";-."
            ],
            "ai": [
                "=-O",
                "=O",
                "=-o",
                "=0",
                "O_O",
                "O_o",
                "o_O",
                "O_0",
                "o_0",
                "0_O",
                "0_o"
            ],
            "aj": [
                ":-*",
                ":*",
                ":-{}",
                ":{}",
                "+{}",
                "={}",
                "^.^"
            ],
            "ak": [
                ":'(",
                ":-'("
            ],
            "al": [
                ":-X",
                ":-x",
                "X:",
                "x:",
                ":-#",
                ":#"
            ],
            "am": [
                ">:o",
                ">:O",
                ">+O",
                ">:o",
                ">+o",
                ">=o",
                ":-@"
            ],
            "an": [
                ":-|",
                ":|",
                "=|"
            ],
            "ao": [
                ":-\\",
                ":-/",
                ":\\"
            ],
            "ap": [
                "*JOKINGLY*",
                "8P",
                "8p"
            ],
            "aq": [
                "]:->",
                "}:->",
                "]:>",
                "}:>",
                ">:-]",
                ">:]",
                "*DIABLO*"
            ],
            "ar": [
                "[:-}",
                "[:}"
            ],
            "as": [
                "*KISSED*"
            ],
            "at": [
                ":-!",
                ";-!",
                ":!",
                ";!",
                ":-~",
                ";-~"
            ],
            "au": [
                "*TIRED*",
                "|-0"
            ],
            "av": [
                "*STOP*"
            ],
            "aw": [
                "*KISSING*"
            ],
            "ax": [
                "@}->--",
                "@}-:--",
                "@>}--`---"
            ],
            "ay": [
                "*THUMBS*"
            ],
            "az": [
                "*DRINK*"
            ],
            "ba": [
                "*LOVE*"
            ],
            "bb": [
                "@="
            ],
            "bc": [
                "*HELP*"
            ],
            "bd": [
                "\\m/"
            ],
            "be": [
                "%)",
                "%-)",
                ":$"
            ],
            "bf": [
                "*OK*"
            ],
            "bg": [
                "*WASSUP*",
                "*SUP*"
            ],
            "bh": [
                "*SORRY*"
            ],
            "bi": [
                "*BRAVO*"
            ],
            "bj": [
                "*ROFL*",
                "*LOL*"
            ],
            "bk": [
                "*PARDON*",
                "=]"
            ],
            "bl": [
                "*NO*"
            ],
            "bm": [
                "*CRAZY*"
            ],
            "bn": [
                "*DONT_KNOW*",
                "*UNKNOWN*"
            ],
            "bo": [
                "*DANCE*"
            ],
            "bp": [
                "*YAHOO*",
                "*YAHOO!*"
            ],
            "bq": [
                "*HI*",
                "*PREVED*",
                "*PRIVET*",
                "*HELLO*"
            ],
            "br": [
                "*BYE*"
            ],
            "bs": [
                "*YES*"
            ],
            "bt": [
                ";D",
                "*ACUTE*"
            ],
            "bu": [
                "*WALL*",
                "*DASH*"
            ],
            "bv": [
                "*WRITE*",
                "*MAIL*"
            ],
            "bw": [
                "*SCRATCH*"
            ]
        }
    }

});
